import React, { FC } from 'react';
import  styles from './Youtube.module.scss';


interface YoutubeProps {}

const Youtube: FC<YoutubeProps> = () => {
  return (
<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clipPath="url(#clip0_31_3351)">
<g clipPath="url(#clip1_31_3351)">
<path d="M19.5822 5.53381C19.3521 4.66773 18.6744 3.98565 17.8138 3.75418C16.2542 3.3335 10 3.3335 10 3.3335C10 3.3335 3.74583 3.3335 2.18617 3.75418C1.32554 3.98565 0.647729 4.66773 0.417871 5.53381C0 7.10362 0 10.379 0 10.379C0 10.379 0 13.6542 0.417871 15.2242C0.647729 16.0903 1.32554 16.7722 2.18608 17.004C3.74575 17.4245 9.99992 17.4245 9.99992 17.4245C9.99992 17.4245 16.2542 17.4245 17.8137 17.004C18.6743 16.7723 19.352 16.0903 19.5821 15.2242C20 13.6543 20 10.3791 20 10.3791C20 10.3791 20.0001 7.10361 19.5822 5.53381Z" fill="#FF0000"/>
<path d="M7.95453 13.3523L13.1818 10.3787L7.95453 7.40479V13.3523Z" fill="white"/>
</g>
</g>
<defs>
<clipPath id="clip0_31_3351">
<rect width="20" height="20" fill="white"/>
</clipPath>
<clipPath id="clip1_31_3351">
<rect width="20" height="20" fill="white"/>
</clipPath>
</defs>
</svg>

  );
};



export default Youtube;
